<template>
<!--    <div>-->
<!--        <div class="card-header border-bottom">-->
<!--            <div class="row">-->
<!--                <div class="col-6 text-left">-->
<!--                    <h5 class="card-title">{{name}}</h5>-->
<!--                </div>-->
<!--            </div>-->
<!--        </div>-->
        <div class="card-body" v-if="input_fields.length>0">
            <template v-for="(field, index1) in input_fields">
                <div class="row align-items-center m-b-10" v-if="field.type !== 'json'">
                    <div class="col-sm-12 col-md-4 col-lg-4">
                        <label class="form-label font-weight-bold">{{field.label}}</label>
                        <small class="form-text text-muted" id="helper-text" v-if="field.description">{{field.description}}</small>
                    </div>
                    <div class="col-sm-12 col-md-8 col-lg-8">
                        <input :id="index1+'_'+id+'_'+field.db" :name="index1+'_'+id+'_'+field.db"
                               :class="{'is-invalid': submitted && errors.has(index1+'_'+id+'_'+field.db)}"
                               :placeholder="field.readonly ? field.label.slice(field.label.indexOf(' ')) : 'Enter '+field.label.slice(field.label.indexOf(' '))"
                               :data-vv-as="field.label"
                               :readonly="field.readonly"
                               :type="field.type"
                               @input="calculate(field.db)"
                               v-model="report[id][field.db]"
                               class="form-control"
                               v-validate="field.required ? 'required': ''">
                        <div class="invalid-feedback" v-if="submitted && errors.has(index1+'_'+id+'_'+field.db)">{{
                            errors.first(index1+'_'+id+'_'+field.db) }}
                        </div>
                    </div>
                    <!--        <div :key="index" class="row" v-for="index in Math.ceil(input_fields.length/2)">-->
                    <!--            <div class="col-sm-12 col-lg-6">-->
                    <!--                <div class="form-group row" v-if="input_fields[(index-1)*2]">-->
                    <!--                    <label class="col-sm-5 control-label">{{input_fields[(index-1)*2].label}}</label>-->
                    <!--                    <div class="col-sm-7">-->
                    <!--                    </div>-->
                    <!--                </div>-->
                    <!--            </div>-->
                    <!--            <div class="col-sm-12 col-lg-6">-->
                    <!--                <div class="form-group row" v-if="input_fields[(index-1)*2+1]">-->
                    <!--                    <label class="col-sm-5 control-label">{{input_fields[(index-1)*2+1].label}}</label>-->
                    <!--                    <div class="col-sm-7">-->
                    <!--                    </div>-->
                    <!--                </div>-->
                    <!--            </div>-->
                    <!--        </div>-->
                </div>
                <h6 class="text-divider text-left" v-else><span class="pl-0">{{field.label}}</span></h6>
                <template v-for="(sub_field, index2) in field.fields">
                    <div class="row align-items-center m-b-10" v-if="sub_field.type !== 'json'">
                        <div class="col-sm-12 col-md-4 col-lg-4">
                            <label class="form-label custom-pl-1">{{sub_field.label}}</label>
                            <small class="form-text text-muted" id="sub-helper-text" v-if="sub_field.description">{{sub_field.description}}</small>
                        </div>
                        <div class="col-sm-12 col-md-8 col-lg-8">
                            <input :id="index1+'_'+index2+'_'+id+'_'+sub_field.db" :name="index1+'_'+index2+'_'+id+'_'+sub_field.db"
                                   :placeholder="sub_field.readonly ? sub_field.label.slice(sub_field.label.indexOf(' ')) : 'Enter '+sub_field.label.slice(sub_field.label.indexOf(' '))"
                                   :type="sub_field.type"
                                   @input="calculate(sub_field.db)"
                                   class="form-control"
                                   v-model="report[id][field.db][sub_field.db]"
                                   :readonly="sub_field.readonly">
                        </div>
                    </div>
                    <h6 class="text-divider text-left" v-else><span class="custom-pl-1">{{sub_field.label}}</span></h6>
                    <template v-for="(sub_sub_field, index3) in sub_field.fields">
                        <div class="row align-items-center m-b-10" v-if="sub_sub_field.type !== 'json'">
                            <div class="col-sm-12 col-md-3 col-lg-4">
                                <label class="form-label custom-pl-2">{{sub_sub_field.label}}</label>
                                <small class="form-text text-muted" id="sub-sub-helper-text"
                                       v-if="sub_sub_field.description">{{sub_sub_field.description}}</small>
                            </div>
                            <div class="col-sm-12 col-md-9 col-lg-8">
                                <input :id="index1+'_'+index2+'_'+id+'_'+sub_sub_field.db" :name="index1+'_'+index2+'_'+id+'_'+sub_sub_field.db"
                                       :placeholder="sub_sub_field.readonly ? sub_sub_field.label.slice(sub_sub_field.label.indexOf(' ')) : 'Enter '+sub_sub_field.label.slice(sub_sub_field.label.indexOf(' '))"
                                       :type="sub_sub_field.type"
                                       @input="calculate(sub_sub_field.db)"
                                       class="form-control"
                                       v-model="report[id][field.db][sub_field.db][sub_sub_field.db]"
                                       :readonly="sub_sub_field.readonly">
                            </div>
                        </div>
                        <h6 class="text-divider text-left" v-else><span class="custom-pl-2">{{sub_sub_field.label}}</span></h6>
                        <template v-for="(sub_sub_sub_field, index4) in sub_sub_field.fields">
                            <div class="row align-items-center m-b-10" v-if="sub_sub_sub_field.type !== 'json'">
                                <div class="col-sm-12 col-md-3 col-lg-4">
                                    <label class="form-label custom-pl-3">{{sub_sub_sub_field.label}}</label>
                                    <small class="form-text text-muted" id="sub-sub-sub-helper-text"
                                           v-if="sub_sub_sub_field.description">{{sub_sub_sub_field.description}}</small>
                                </div>
                                <div class="col-sm-12 col-md-9 col-lg-8">
                                    <input :id="index1+'_'+index2+'_'+index3+'_'+index4+'_'+id+'_'+sub_sub_sub_field.db" :name="index1+'_'+index2+'_'+index3+'_'+index4+'_'+id+'_'+sub_sub_sub_field.db"
                                           :placeholder="sub_sub_sub_field.readonly ? sub_sub_sub_field.label.slice(sub_sub_sub_field.label.indexOf(' ')) : 'Enter '+sub_sub_sub_field.label.slice(sub_sub_sub_field.label.indexOf(' '))"
                                           :type="sub_sub_sub_field.type"
                                           @input="calculate(sub_sub_sub_field.db)"
                                           class="form-control"
                                           v-model="report[id][field.db][sub_field.db][sub_sub_field.db][sub_sub_sub_field.db]"
                                           :readonly="sub_sub_sub_field.readonly">
                                </div>
                            </div>
                        </template>
                    </template>
                </template>
            </template>
        </div>
<!--    </div>-->
</template>

<script>
    export default {
        name: "AddFinancialReportTabContent",
        props: ["name", "id", "input_fields", "report", "events"],
        created() {
            this.events.$on('reporttab:validate', () => {
                this.validate();
            });
        },
        data() {
            return {
                submitted: false,
            }
        },
        methods: {
            validate(e) {
                this.submitted = true;
                this.$validator.validate();
            },
            calculate() {
                if (this.id === 'balance_sheet') {
                    this.report.balance_sheet.equity_and_liabilities.stockholders_fund.total_shareholders_funds = Number(this.report.balance_sheet.equity_and_liabilities.stockholders_fund.share_capital) +
                        Number(this.report.balance_sheet.equity_and_liabilities.stockholders_fund.reserves_and_surplus);
                    this.report.balance_sheet.equity_and_liabilities.non_current_liabilities.total_non_current_liabilities = Number(this.report.balance_sheet.equity_and_liabilities.non_current_liabilities.long_term_borrowings) +
                        Number(this.report.balance_sheet.equity_and_liabilities.non_current_liabilities.deferred_tax_liabilities) +
                        Number(this.report.balance_sheet.equity_and_liabilities.non_current_liabilities.other_long_term_liabilities);
                    this.report.balance_sheet.equity_and_liabilities.current_liabilities.total_current_liabilities = Number(this.report.balance_sheet.equity_and_liabilities.current_liabilities.short_term_borrowings) +
                        Number(this.report.balance_sheet.equity_and_liabilities.current_liabilities.trade_parables) +
                        Number(this.report.balance_sheet.equity_and_liabilities.current_liabilities.other_current_liabilities);
                    this.report.balance_sheet.equity_and_liabilities.total_equity = Number(this.report.balance_sheet.equity_and_liabilities.stockholders_fund.total_shareholders_funds) +
                            Number(this.report.balance_sheet.equity_and_liabilities.non_current_liabilities.total_non_current_liabilities) +
                            Number(this.report.balance_sheet.equity_and_liabilities.current_liabilities.total_current_liabilities);

                    this.report.balance_sheet.assets.non_current_assets.fixed_assets.total_of_fixed_assets = Number(this.report.balance_sheet.assets.non_current_assets.fixed_assets.tangible_assets) +
                            Number(this.report.balance_sheet.assets.non_current_assets.fixed_assets.intangible_assets);
                    this.report.balance_sheet.assets.non_current_assets.total_non_current_assets = Number(this.report.balance_sheet.assets.non_current_assets.fixed_assets.total_of_fixed_assets) +
                            Number(this.report.balance_sheet.assets.non_current_assets.non_current_investments) +
                        Number(this.report.balance_sheet.assets.non_current_assets.deferred_tax_assets) +
                        Number(this.report.balance_sheet.assets.non_current_assets.long_term_loans_advances);
                    this.report.balance_sheet.assets.current_assets.total_current_assets = Number(this.report.balance_sheet.assets.current_assets.current_investments) +
                        Number(this.report.balance_sheet.assets.current_assets.inventories) +
                        Number(this.report.balance_sheet.assets.current_assets.trade_receivables) +
                        Number(this.report.balance_sheet.assets.current_assets.cash_and_cash_equivalents) +
                        Number(this.report.balance_sheet.assets.current_assets.short_term_loans_advances) +
                        Number(this.report.balance_sheet.assets.current_assets.other_current_assets);

                    this.report.balance_sheet.assets.total_assets = Number(this.report.balance_sheet.assets.non_current_assets.total_non_current_assets) +
                        Number(this.report.balance_sheet.assets.current_assets.total_current_assets);
                }


                if (this.id === 'profit_and_loss') {
                    this.report.profit_and_loss.revenue.total_revenue = Number(this.report.profit_and_loss.revenue.revenue_from_operations) +
                            Number(this.report.profit_and_loss.revenue.other_income);

                    this.report.profit_and_loss.expenses.total_expenses = Number(this.report.profit_and_loss.expenses.cost_of_rendering_services) +
                        Number(this.report.profit_and_loss.expenses.purchases) +
                        Number(this.report.profit_and_loss.expenses.increase_decrease) +
                        Number(this.report.profit_and_loss.expenses.employee_benefit_expense) +
                        Number(this.report.profit_and_loss.expenses.finance_cost) +
                        Number(this.report.profit_and_loss.expenses.depreciation) +
                        Number(this.report.profit_and_loss.expenses.other_expenses);

                    this.report.profit_and_loss.profit_before_tax = Number(this.report.profit_and_loss.revenue.total_revenue) - Number(this.report.profit_and_loss.expenses.total_expenses);

                    this.report.profit_and_loss.tax_expenses.total_tax_expenses = Number(this.report.profit_and_loss.tax_expenses.current_tax) +
                        Number(this.report.profit_and_loss.tax_expenses.current_tax_expense) +
                        Number(this.report.profit_and_loss.tax_expenses.deferred_tax);

                    this.report.profit_and_loss.profit_after_tax = Number(this.report.profit_and_loss.profit_before_tax) - Number(this.report.profit_and_loss.tax_expenses.total_tax_expenses);

                }
            }
        }
    }
</script>

<style scoped>
    .text-divider {
        margin: 2em 0;
        line-height: 1px;
        text-align: left !important;
    }

    .custom-pl-1 {
        padding-left: 1.5rem !important;
    }
    .custom-pl-2 {
        padding-left: 3rem !important;
    }
    .custom-pl-3 {
        padding-left: 4.5rem !important;
    }
    .custom-pl-4 {
        padding-left: 6rem !important;
    }
</style>
